/**
 * aligned's `rate_cards` collection (`models/manager/billing_models/rate_card/rate_card_model.dart`).
 * Every customer gets a default rate card on creation — see
 * `services/customers.ts:createCustomer`.
 */
export interface RateCard {
  id: string;
  customerId: string;
  name: string | null;
  description: string | null;
  hourlyRate: number | null;
  isDefault: boolean;
}

/** Aligned's default customer billing rate, expressed in micro-USD/hour. */
export const DEFAULT_RATE_CARD_HOURLY_RATE_MICRO_USD = 50_000_000;

type Data = Record<string, unknown>;

const str = (v: unknown): string | null => (typeof v === 'string' ? v : null);
const numOrNull = (v: unknown): number | null => (typeof v === 'number' ? v : null);
const bool = (v: unknown): boolean => v === true;

export function mapRateCard(id: string, data: Data): RateCard {
  return {
    id,
    customerId: str(data.customerId) ?? '',
    name: str(data.name),
    description: str(data.description),
    hourlyRate: numOrNull(data.hourlyRate),
    isDefault: bool(data.isDefault),
  };
}
